// Test IDs for matrimonial app features (nav, search, profile, etc.)

export const NAV = {
        logo: 'nav-logo-link',
        home: 'nav-home-link',
        search: 'nav-search-link',
        shortlist: 'nav-shortlist-link',
        messages: 'nav-messages-link',
        notifications: 'nav-notifications-link',
        premium: 'nav-premium-link',
        admin: 'nav-admin-link',
        login: 'nav-login-link',
        register: 'nav-register-link',
        profile: 'nav-profile-link',
        logout: 'nav-logout-button',
        mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
        registerCta: 'hero-register-cta',
        browseCta: 'hero-browse-cta',
        searchButton: 'hero-search-button',
        ageMin: 'hero-age-min-select',
        ageMax: 'hero-age-max-select',
        gender: 'hero-gender-select',
        denomination: 'hero-denomination-select',
};

export const PROFILE_CARD = {
        view: 'profile-card-view-link',
        shortlist: 'profile-card-shortlist-button',
        interest: 'profile-card-interest-button',
};

export const PROFILE_VIEW = {
        shortlist: 'profile-view-shortlist-button',
        interest: 'profile-view-interest-button',
        message: 'profile-view-message-button',
};

export const PROFILE_SETUP = {
        saveButton: 'profile-setup-save-button',
        photoUpload: 'profile-setup-photo-upload',
        deletePhoto: 'profile-setup-delete-photo-button',
};

export const SEARCH = {
        ageMin: 'search-age-min-input',
        ageMax: 'search-age-max-input',
        gender: 'search-gender-select',
        denomination: 'search-denomination-select',
        city: 'search-city-input',
        profession: 'search-profession-input',
        submit: 'search-submit-button',
};

export const MESSAGES = {
        send: 'messages-send-button',
        input: 'messages-text-input',
        conversation: 'messages-conversation-item',
};

export const PREMIUM = {
        select: 'premium-select-button',
};

export const ADMIN = {
        approve: 'admin-approve-button',
        reject: 'admin-reject-button',
        ban: 'admin-ban-button',
};
